/**
 * Copy da vitrine do Kanban. O produto se chama Kanban; "CRM" aparece ao lado (`aka`) para a pessoa correlacionar, porque
 * quem não conhece Kanban entende CRM. Os dois termos são explicados no glossário. A origem do lead (Instagram ou Facebook) é detectada pelo anúncio que abre o WhatsApp
 * (`apps/api/services/crm/originChannel.js`): não prometa integração de formulário de leads.
 */
const ASSETS = '/assets';

export default {
    title: 'Kanban',
    aka: 'CRM',
    art: 'o Kanban',
    heroTitle: ['CRM para ver cada venda andar.', 'Do anúncio ao fechamento.'],
    summary:
        'O Kanban é o CRM da plataforma: onde ficam seus clientes e as vendas de cada um. É um quadro, com uma coluna para cada etapa, um cartão para cada negociação, e a origem do anúncio (Instagram ou Facebook) já vem preenchida.',
    stripLabel: 'Funciona com',
    strip: [
        { name: 'CRM da plataforma', logo: null },
        { name: 'Instagram', logo: `${ASSETS}/Instagram_logo.svg` },
        { name: 'AdvBox', logo: `${ASSETS}/advbox.svg` },
        { name: 'Projuris', logo: `${ASSETS}/projuris_icon.svg` },
        { name: 'Pipedrive', logo: `${ASSETS}/pipedrive.svg` },
    ],
    painTitle: 'A proposta foi enviada e ninguém lembrou de cobrar.',
    before: 'A proposta da Marina está numa planilha. Ninguém lembra de atualizar, e ninguém sabe se ela veio de um anúncio ou de uma indicação.',
    after: 'A proposta é um cartão na coluna Proposta. A equipe inteira vê em que etapa cada cliente está e de onde ele veio.',
    demoTitle: 'Experimente o Kanban, o quadro do CRM.',
    demoSub: 'Simule a chegada de um lead do Instagram ou do Facebook e veja o cartão nascer sozinho, com a origem.',
    glossary: [
        { term: 'CRM', def: 'O sistema que guarda seus clientes e as vendas de cada um.', icon: 'briefcase' },
        { term: 'Kanban', def: 'Um quadro com colunas, uma para cada etapa da venda.', icon: 'board' },
        { term: 'Cartão', def: 'Uma negociação, com o cliente e o valor.', icon: 'card' },
        { term: 'Origem', def: 'De onde o cliente veio, como um anúncio do Instagram ou do Facebook.', icon: 'megaphone' },
    ],
    videoTitle: 'As automações do CRM, no sistema real.',
    poster: `${ASSETS}/showcase/crm-automacoes.webp`,
    chapters: ['Criar o funil', 'Mover as negociações', 'Registrar ganho ou perda'],
    exTitle: 'Abra a tela e veja as automações do funil.',
    exSub: 'Esta é a tela real das automações do CRM. Escolha uma regra e a peça sai da tela.',
    groups: [
        { title: 'Vender', items: ['Quadro por etapa, com arrastar e soltar', 'Cartão ligado ao contato e à conversa', 'Vários quadros por equipe ou produto', 'Ganho e perda com motivo'] },
        { title: 'Saber de onde veio', items: ['Origem do anúncio (Instagram e Facebook)', 'Outros canais (TikTok, Site) marcados à mão', 'Automações por funil'] },
        { title: 'Integrar', items: ['CRM da plataforma', 'AdvBox', 'Projuris', 'Pipedrive'] },
    ],
    steps: [
        { title: 'Experimente', body: 'Libere o CRM e crie o seu primeiro quadro.' },
        { title: 'Receba os leads', body: 'Crie os cartões ou deixe os anúncios do Instagram e do Facebook trazerem os clientes.' },
        { title: 'Acompanhe', body: 'Arraste entre as etapas e veja os números do funil.' },
    ],
    extraFaq: { q: 'Posso usar o AdvBox, o Projuris ou o Pipedrive?', a: 'Pode. Você escolhe o sistema, e a página do CRM é a mesma.' },
    finalTitle: 'Tire o funil da planilha.',
    finalBullets: ['Cada venda num quadro, com a origem do anúncio', 'Automações por funil', 'Contato e conversa dentro de cada cartão'],
};
